import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Button, Card, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./css/ShopCard.css";
import { FaUser, FaShoppingCart, FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import missionimage from "./img/missionofyaasaai.jpeg";

function ShopCard() {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const sliderRef = React.useRef(null);
  const [showPopup, setShowPopup] = useState(true); // 💡 For showing popup
  const [isVideo, setIsVideo] = useState(false); //
  const [showModal, setShowModal] = useState(false);
  const [popupImage, setPopupImage] = useState("");
  useEffect(() => {
    fetch("https://yaasaai.com/myphpapi/allvegshop.php") // Updated API URL
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch shop data.");
        return response.json();
      })
      .then((data) => {
        if (!data || data.length === 0) {
          setError("No vegetable shops available.");
        } else {
          setShops(data);
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetch(
      "https://yaasaai.com/myphpapi/get_slider_images.php?action=get-slider-images"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data.length > 0) {
          setPopupImage("https://yaasaai.com" + data.data[0].image_url);
          // Do NOT set showPopup here
        }
      })
      .catch((err) => console.error("Popup image error:", err));
  }, []);

  const handleVisitShop = (shopId) => {
    const userEmail = localStorage.getItem("userEmail");
    //tracking
    if (typeof window.gtag === "function") {
      window.gtag("event", "shop_veg_visited", {
        shop_id: shopId,
        user_id: userEmail || "unknown",
      });
    }

    navigate("/shop_profile", { state: { userEmail, shopId } });
  };

  //pop show timing
  useEffect(() => {
    // Get current IST time
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istTime = new Date(utc + 5.5 * 60 * 60 * 1000);

    const hours = istTime.getHours();
    const dateKey = istTime.toISOString().split("T")[0]; // "YYYY-MM-DD"

    // Determine current time slot
    let slot = null;
    if (hours >= 7 && hours < 16) {
      slot = "morning";
    } else if (hours >= 16 && hours <= 23) {
      slot = "evening";
    }

    if (slot) {
      const storageKey = `popup_${slot}`;
      try {
        const popupData = JSON.parse(localStorage.getItem(storageKey));

        // Show popup only if not already shown today in this slot
        if (!popupData || popupData.date !== dateKey) {
          setShowPopup(true);
          localStorage.setItem(
            storageKey,
            JSON.stringify({ date: dateKey, shown: true })
          );
        } else {
          setShowPopup(false); // Don't show again
        }
      } catch (err) {
        // If JSON is invalid, reset it
        setShowPopup(true);
        localStorage.setItem(
          storageKey,
          JSON.stringify({ date: dateKey, shown: true })
        );
      }
    }
  }, []);

  // Responsive settings for the carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 7 } },
      { breakpoint: 1024, settings: { slidesToShow: 6 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 600, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
      { breakpoint: 360, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div className="shop-container">
      <div
        className="offer-shop-section"
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: "0.5rem",
        }}
      >
        {/* ✅ Popup Modal with Image */}
        {showPopup && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // 🟢 Key: center vertically
              overflow: "hidden",
              padding: "1rem", // optional, to avoid mobile cutoff
            }}
          >
            <div style={{ position: "relative" }}>
              <img
                src={popupImage}
                alt="Special Offer"
                style={{
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  borderRadius: "20px",
                  boxShadow: "0 0 20px rgba(0,0,0,0.3)",
                  objectFit: "contain",
                  display: "block",
                  margin: "auto", // 🟢 ensures it's centered inside the flex box
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://yaasaai.com/slider/default.jpg";
                }}
              />

              <button
                onClick={() => setShowPopup(false)}
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "-10px",
                  background: "red",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  padding: "6px 10px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>
          </motion.div>
        )}
      </div>
      {/*  Yaasaai ko jaane Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        scrollable
      >
        <Modal.Header
          closeButton
          className="j
             ustify-content-center modal-footer-custom"
        >
          <h4 style={{ color: "green", fontWeight: "bold" }}>
            🥬 यासाई को जाने...
          </h4>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "black",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div>
            <h4
              className="font-bold mb-2  text-center"
              style={{ color: "coral" }}
            >
              🛒 अपनी सब्जी-फलों की खरीदारी, अब आसान और स्मार्ट! 🍎🥦
            </h4>
            <div style={{ animation: "fadeIn 1s ease-in-out", color: "#fff" }}>
              <p
                style={{
                  animation: "slideUp 0.8s ease-out forwards",
                  animationDelay: "0.2s",
                  opacity: 0,
                }}
              >
                ✅{" "}
                <strong className="p-heading">
                  1.अपनी पसंदीदा दुकान से खरीदारी का विकल्प
                </strong>
                <br />
                <span style={{ display: "inline-block", marginTop: "4px" }}>
                  हर किसी की अपनी पसंद होती है ! <br />
                  अब आप अपनी भरोसेमंद सब्जी या फलों की दुकान से सीधी खरीदारी कर
                  सकते हैं ।
                </span>
              </p>

              <p
                style={{
                  animation: "slideUp 0.8s ease-out forwards",
                  animationDelay: "0.4s",
                  opacity: 0,
                }}
              >
                🛍️{" "}
                <strong className="p-heading">
                  2. एक से अधिक दुकान से सब्जी और फल की खरीददारी का विकल्प
                </strong>
                <br />
                <span style={{ display: "inline-block", marginTop: "4px" }}>
                  सिर्फ एक नहीं - आप कई दुकानों से एक ही बार में ऑर्डर कर सकते
                  हैं । <br />
                  ज़्यादा वैरायटी, बेहतर क्वालिटी, और एक ही डिलीवरी में सब कुछ !
                </span>
              </p>

              <p
                style={{
                  animation: "slideUp 0.8s ease-out forwards",
                  animationDelay: "0.6s",
                  opacity: 0,
                }}
              >
                📍{" "}
                <strong className="p-heading">
                  3. नजदीकी दुकानों से खरीददारी करने का विकल्प
                </strong>
                <br />
                <span style={{ display: "inline-block", marginTop: "4px" }}>
                  अपने लोकेशन के आस-पास की दुकानें खोजें । <br />
                  ताकी आपको ताजा सब्जी और फल मिले, और डिलीवरी का समय कम है।
                </span>
              </p>

              <p
                style={{
                  animation: "slideUp 0.8s ease-out forwards",
                  animationDelay: "0.8s",
                  opacity: 0,
                }}
              >
                🚚 <strong className="p-heading">4. सुपर आसान डिलीवरी</strong>
                <br />
                <span style={{ display: "inline-block", marginTop: "4px" }}>
                  चिंता छोड़िये ! <br />
                  हम लाते हैं आपके दरवाजे तक सब्जी और फल - तेज़, ताज़ा और संपर्क
                  रहित डिलीवरी के साथ ।
                </span>
              </p>

              <hr style={{ margin: "20px 0", borderColor: "#f9e79f" }} />

              <p
                className="text-center"
                style={{
                  fontSize: "15px",
                  color: "green",
                  fontWeight: "bold",
                  animation: "popIn 1s ease-out forwards",
                  animationDelay: "1s",
                  opacity: 0,
                }}
              >
                🌟 तो देर किस बात की ? अपना ऑर्डर लगाइये और मजेदार शॉपिंग का मजा
                लीजिये !
              </p>

              <style>{`
    @keyframes slideUp {
      from {
        transform: translateY(30px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes popIn {
      0% {
        transform: scale(0.8);
        opacity: 0;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }

    p {
      transition: all 0.5s ease-in-out;
      margin-bottom: 20px;
    }
  `}</style>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div>
        <button
          onClick={() => {
            // ✅ Track GA4 event
            if (typeof window.gtag === "function") {
              window.gtag("event", "yaasaai_button_clicked", {
                button_text: "🥬 यासाई को जाने →",
                user_id: localStorage.getItem("userEmail") || "guest",
                location: "homepage", // or any page context if needed
              });
            }

            // ✅ Show modal after tracking
            setShowModal(true);
          }}
          className="animated-button"
        >
          🥬 यासाई को जाने →
        </button>
      </div>

      <div class="blinking_banner">
        Fresh vegetables and fruits available at the best prices !
      </div>
      <h5 align="center">Vegetable Shops</h5>
      <div className="carousel-container">
        <Button
          variant="success"
          className="slider-button prev"
          onClick={() => sliderRef.current.slickPrev()}
        >
          &#10094;
        </Button>
        <Slider ref={sliderRef} {...settings}>
          {shops.length > 0 ? (
            shops.map((shop) => {
              const imageUrl = `https://yaasaai.com/ShopImages/${shop.shop_image}`;

              return (
                <div key={shop.shop_id}>
                  <Card style={{ width: "7rem" }} className="shop-card">
                    <div
                      style={{
                        width: "100%",
                        height: "100px",
                        /*objectFit: "cover",
                        overflow: "hidden",
                        position: "relative",*/
                      }}
                    >
                      <Card.Img
                        variant="top"
                        src={imageUrl}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          imageRendering: "auto",
                          /*transition: "transform 0.3s ease, position 0.3s",*/
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "default-image.jpg";
                        }}
                        className="veg-image img-fluid rounded"
                      />
                    </div>

                    <Card.Body>
                      <Card.Title
                        className="shop_title"
                        style={{ fontSize: "10px" }}
                      >
                        {shop.shop_name}
                      </Card.Title>
                      <Card.Title style={{ fontSize: "8px", color: "green" }}>
                        open 11 am
                      </Card.Title>

                      <Card.Text className="shop-address">
                        <strong>
                          <FaMapMarkerAlt
                            size={10}
                            className="blinking-icon me-1"
                          />
                        </strong>
                        {shop.shop_address}
                      </Card.Text>

                      {/* ✅ Show message if shop is closed */}
                      {shop.shop_quantity === "closed" ? (
                        <Card.Text
                          style={{
                            padding: "6px 12px",
                            fontSize: "12px",
                            backgroundColor: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "arrow",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            transition: "0.3s",
                          }}
                        >
                          Closed
                        </Card.Text>
                      ) : (
                        <Button
                          onClick={() => handleVisitShop(shop.shop_id)}
                          style={{
                            padding: "6px 12px",
                            fontSize: "12px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            transition: "0.3s",
                          }}
                          onMouseOver={(e) =>
                            (e.target.style.backgroundColor = "#45a049")
                          }
                          onMouseOut={(e) =>
                            (e.target.style.backgroundColor = "#4CAF50")
                          }
                        >
                          Visit
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </div>
              );
            })
          ) : (
            <p align="center">No shops available</p>
          )}
        </Slider>

        <Button
          variant="success"
          className="slider-button next"
          onClick={() => sliderRef.current.slickNext()}
        >
          &#10095;
        </Button>
      </div>
    </div>
  );
}

export default ShopCard;
